import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    param: {type: String, default: "type"}
  }

  go() {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set(this.paramValue, this.element.value)
    window.Turbo.visit(url.toString())
  }
}
